// tslint:disable:no-any

import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import { DisplayDate } from '../components/Display';

import 'react-datepicker/dist/react-datepicker.css';

export interface IDivesFilterElementProps {
    label: string;
    name: string;
    onChange: (e: Event, name: string) => void;
}

class DivesFilterElement extends Component<IDivesFilterElementProps> {
    render() {
        return (
            <div className="filterItem default">
                <label>{this.props.label} :</label>
                <input
                    type="text"
                    name={this.props.name}
                    onChange={e =>
                        this.props.onChange(e as any, this.props.name)
                    }
                />
            </div>
        );
    }
}

export interface IDivesFilterElementDateProps {
    label: string;
    name: string;
    onChange: (name: string) => void;
}

interface IDivesFilterElementDateState {
    startDate: any;
}

class DivesFilterElementDate extends Component<
    IDivesFilterElementDateProps,
    IDivesFilterElementDateState
> {
    constructor(props: IDivesFilterElementDateProps) {
        super(props);
        this.state = {
            startDate: null
        };
    }

    handleChange(date: any) {
        this.setState(
            {
                startDate: date
            },
            () => {
                this.props.onChange(
                    date === null ? null : date.format('Y-MM-DD')
                );
            }
        );
    }

    render() {
        return (
            <div className="filterItem units date">
                <label>{this.props.label} :</label>
                <DatePicker
                    dateFormat={DisplayDate.getFormat()}
                    selected={this.state.startDate}
                    onChange={e => this.handleChange(e)}
                />
            </div>
        );
    }
}

export interface IDivesFilterElementProps {
    label: string;
    name: string;
    onChange: (e: Event, name: string) => void;
}

class DivesFilterElementMeters extends Component<IDivesFilterElementProps> {
    render() {
        return (
            <div className="filterItem units distance">
                <label>{this.props.label} :</label>
                <input
                    type="text"
                    name={this.props.name}
                    onChange={e =>
                        this.props.onChange(e as any, this.props.name)
                    }
                />
            </div>
        );
    }
}

export interface IDivesFilterTableProps {
    handleFind: (f: any) => void;
}

interface IDivesFilterTableState {
    filter: any;
}

class DivesFilterTable extends Component<
    IDivesFilterTableProps,
    IDivesFilterTableState
> {
    // private autoFilter: number | null = null;

    constructor(props: IDivesFilterTableProps) {
        super(props);
        this.state = {
            filter: []
        };

        // this.autoFilter = null;
    }

    handleChangeItem(e: any, name: string) {
        var newFilter = this.state.filter;
        newFilter[name] = e.target.value;
        this.setState(
            {
                filter: newFilter
            },
            () => {
                this.onSubmitFilter();
            }
        );
    }

    handleChangeData(name: string, value: string) {
        var newFilter = this.state.filter;
        newFilter[name] = value;
        this.setState(
            {
                filter: newFilter
            },
            () => {
                this.onSubmitFilter();
            }
        );
    }

    onSubmitFilter() {
        this.props.handleFind(this.state.filter);
    }

    render() {
        return (
            <div className="filterTable cf">
                <div className="filterItems">
                    <DivesFilterElementMeters
                        label="Depth from"
                        name="depthFrom"
                        onChange={e => this.handleChangeItem(e, 'depthFrom')}
                    />

                    <DivesFilterElementMeters
                        label="Depth to"
                        name="depthTo"
                        onChange={e => this.handleChangeItem(e, 'depthTo')}
                    />

                    <div className="divider cf" />

                    <DivesFilterElementDate
                        label="Date from"
                        name="dateFrom"
                        onChange={data =>
                            this.handleChangeData('dateFrom', data)
                        }
                    />

                    <DivesFilterElementDate
                        label="Date to"
                        name="dateTo"
                        onChange={data => this.handleChangeData('dateTo', data)}
                    />

                    <div className="divider cf" />

                    <DivesFilterElement
                        label="Location"
                        name="location"
                        onChange={e => this.handleChangeItem(e, 'location')}
                    />
                </div>
            </div>
        );
    }
}

export default DivesFilterTable;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DivesFilterTable.tsx